module.exports = __webpack_public_path__ + "static/bent-tree-b0eac2fe4ac76a41796c0b2f300e0940.jpg";